export enum VendorType {
  MainBranch = 2,
  Branch = 1
}
